import * as React from 'react';
import type {
  ScheduledReportType,
  ScheduledReportStatus,
  ScheduledReport,
} from 'contracts/scheduled-reports';
import { api, handleApiError, applyQueryString } from 'services/api';

type Payload = {
  type: ScheduledReportType,
  statuses?: ScheduledReportStatus[],
}

export const useFetchScheduledReports = <T extends ScheduledReport>() => {
  const fetchScheduledReports = React.useCallback(async (payload: Payload) => {
    try {
      const url = applyQueryString('/scheduled-reports', {
        ...payload,
      });
      const { data } = await api.get<T[]>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchScheduledReports,
  };
};